import { Api } from 'utils';

class ServiceService {
  static get = async (params?: any) => Api.createResponse('app/services/', params);
  static save = async (params?: any) => Api.createResponse('app/services/save', params);
  static saveChat = async (params?: any) => Api.createResponse('app/services/save-chat', params);
  static getStatus = async (params?: any) => Api.createResponse('app/services/status', params);

  static admin = {
    get: async (params?: any) => Api.createResponse('admin/services/', params),
    update: async (params?: any) => Api.createResponse('admin/services/update', params),
    getPrices: async (params?: any) => Api.createResponse('admin/services/prices', params),
  };

  static calling = {
    get: async (params?: any) =>
      Api.createResponse('app/services/calling/get-calling-hours', params),
    create: async (params?: any) =>
      Api.createResponse('app/services/calling/save-calling-hours', params),
    edit: async (params?: any) =>
      Api.createResponse('app/services/calling/edit-calling-hours', params),
    delete: async (params?: any) =>
      Api.createResponse('app/services/calling/delete-calling-hours', params),
  };
}

export default ServiceService;
